import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { faExclamationCircle, faInfoCircle, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { alumniReasonList, employmentTypeList, namewithSpace } from 'src/app/utils/constants';
import { environment } from 'src/environments/env';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { StepperOrientation } from '@angular/cdk/stepper';
import { map, Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { HelpdeskService } from '../admin/helpdesk/helpdesk.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserDataModalComponent } from 'src/app/component/user-data-modal/user-data-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import Utils from 'src/app/utils/utils';
import { FTEModalComponent } from 'src/app/component/fte-modal/fte-modal.component';

@Component({
  selector: 'app-expired-form-submission',
  standalone: false,
  templateUrl: './expired-form-submission.component.html',
  styleUrl: './expired-form-submission.component.scss'
})
export class ExpiredFormSubmissionComponent implements OnInit, OnDestroy {
  icons = {
    faExclamationCircle,
    faInfoCircle,
    faArrowLeft
  }

  selectedOption: 'MCT' | 'Alumni' | null = null;
  sectiontoShow: string | null = null


  alumniForm: any;
  activeSince: Date | null = null;
  mctSubscriptionEndDate: any | Date = null
  reasonOptions = alumniReasonList;
  isAlumniCheckboxSelected = false;
  // expiredMoreThanThree: boolean | null  = null;

  reinstatementStepTwo: any;
  reinstatementStepOne: any;
  isCheckboxSelected = false;
  formSubmitted: boolean = false;
  employmentTypeList: any = employmentTypeList;
  countryList: any = [];
  public timezoneList: any = [];
  filteredRegion: any = [];
  languageList: any = [];
  stepperOrientation!: Observable<StepperOrientation>;
  show: boolean = false;
  status: any = null
  userId: any | null = null;
  expiredFormSubmit: boolean = false;
  alumniFormSubmitted: boolean = false;
  public snackbar = inject(MatSnackBar);
  public dialogConfig: any = {};
  public simpleDialog!: MatDialogRef<UserDataModalComponent>;
  public FTEDialog!: MatDialogRef<FTEModalComponent>;
  isFirstStepEnable: boolean = true;
  disablesubmitBtn: boolean = false;
  private statusCheckInterval: any;



  constructor(
    private readonly _fb: FormBuilder,
    private readonly sppdashboardService: SppdashboardService,
    breakpointObserver: BreakpointObserver,
    private readonly router: Router,
    private readonly helpService: HelpdeskService,
    private readonly dialogModel: MatDialog,
    private readonly util: Utils,
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 600px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit(): void {
    this.initAlumniForm();
    this.initMctForms();
    this.patchFormData();
    this.getLanguageList();
    this.getCountryList();

    this.sppdashboardService.getUser().subscribe((res: any) => {
      this.sppdashboardService.getTimeZonesByCountryName(res.data.country).subscribe((response: any) => {
        if (response.success) {
          this.timezoneList = response.data;
        }
      }, (error: any) => {
        console.error("Error fetching Timezone List", error);
      });
    })

    this.statusCheckInterval = setInterval(() => {
      this.sppdashboardService.getUser().subscribe((res: any) => {
        this.redirectHomeOnTestout(res);
      })
    }, 10000);
  }

  private redirectHomeOnTestout(res: any) {
    if (res?.data?.status === 'TEST_OUT_OPEN') {
      this.router.navigate(['/home']);
    }
  }


  patchFormData = () => {
    this.sppdashboardService.getUser().subscribe((response: any) => {
      if (response.success && response.data) {

        const res = response.data;
        this.status = res.status;
        this.userId = res.userid;
        this.mctSubscriptionEndDate = res.mctSubscriptionEndDate;
        this.activeSince = new Date(res.firstTimeRegDate);

        if (this.status === 'REINSTATE_SUBMIT' || this.status === 'REINSTATE_REJECT' || this.status === 'TEST_OUT_OPEN') {
          this.sectiontoShow = 'mctReinstatementSection';
          this.isFirstStepEnable = false;
          this.isCheckboxSelected = true;
          if (this.status === 'REINSTATE_SUBMIT') {
            this.reinstatementStepOne.disable();
            this.reinstatementStepTwo.disable();
            this.reinstatementStepOne.updateValueAndValidity();
            this.reinstatementStepTwo.updateValueAndValidity();
          }
        } else {
          this.sectiontoShow = 'selectionPage';
          this.isFirstStepEnable = true;
          this.isCheckboxSelected = false;
          this.reinstatementStepOne.enable();
          this.reinstatementStepTwo.enable();
          this.reinstatementStepTwo.get('mctAgreement')?.disable();
          this.reinstatementStepOne.get('email')?.disable();
          this.reinstatementStepOne.updateValueAndValidity();
          this.reinstatementStepTwo.updateValueAndValidity();
        }

        this.reinstatementStepOne.patchValue({
          firstname: res.firstname,
          lastname: res.lastname,
          email: res.email,
          language: res.language,
          country: res.country,
          timezone: res.timeZone,
          employmentType: res.employmentType,
          alternateEmail: res.alternateEmail,
        });

        this.reinstatementStepTwo.patchValue({
          mctAgreement: res?.mctAgreement,
        });

        this.alumniForm.patchValue({
          firstname: res.firstname,
          lastname: res.lastname,
          email: res.email,
          alumniText: res.alumniText,
          alumniReasons: res.alumniReasons,
          mctAlumniAgreement: res.mctAlumniAgreement
        });
      }

    })
  }

  getLanguageList = () => {
    this.sppdashboardService.getLanguageList().subscribe((response: any) => {
      this.languageList = response;
    }, (error: any) => {
      console.error("Error fetching Language List", error);
    });
  }

  getCountryList = () => {
    this.sppdashboardService.getCountryList().subscribe((response: any) => {
      this.countryList = response;
    }, (error: any) => {
      console.error("Error fetching Country List", error);
    });
  }


  //////////////////////////////////

  // REINSTANENT SECTION START HERE

  //////////////////////////////////

  initMctForms(): void {
    this.reinstatementStepOne = this._fb.group({
      firstname: ["", [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: ["", [Validators.required, Validators.pattern(namewithSpace)]],
      email: [{ value: '', disabled: true }],
      language: ["", Validators.required],
      country: ["", Validators.required],
      timezone: ["", Validators.required],
      employmentType: ["", Validators.required],
      alternateEmail: [{ value: '', disabled: true }, [this.util.customEmailValidator]],
    });

    this.reinstatementStepTwo = this._fb.group({
      mctAgreement: [{ value: '', disabled: true }, Validators.required],
    });
  }


  next() {
    this.reinstatementStepOne.markAllAsTouched();
  }

  agrementDoc = () => {
    this.reinstatementStepTwo.get('mctAgreement')?.enable();
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/mct_agreement/download`;
    window.open(pdfUrl, '_blank');
  }


  submitReInstatementForm() {
    this.formSubmitted = true;
    this.reinstatementStepOne.markAllAsTouched();
    this.reinstatementStepTwo.markAllAsTouched();

    if (this.reinstatementStepTwo.valid && this.reinstatementStepOne.valid && this.isCheckboxSelected) {

      const payload = {
        firstname: this.reinstatementStepOne.value.firstname,
        lastname: this.reinstatementStepOne.value.lastname,
        email: this.reinstatementStepOne.getRawValue()?.email,
        language: this.reinstatementStepOne.value.language,
        country: localStorage.getItem('selectedCountry') || this.reinstatementStepOne.value.country,
        timezone: this.reinstatementStepOne.value.timezone,
        employmentType: this.reinstatementStepOne.value.employmentType,
        alternateEmail: this.reinstatementStepOne.value.alternateEmail,
        mctAgreement: this.reinstatementStepTwo.value.mctAgreement,
      }

      this.sppdashboardService.testOutUser(payload).subscribe((res: any) => {
        if (res.success) {
          res.message = `Thank you for submitting your application.<br/>
                              You may now proceed to the MCT Instructional Skills Assessment.
                              Once payment is completed and the assessment is passed, 
                              you can complete your MCT Program registration and pay your MCT Program Fee.<br/>
                              For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!`;
          res.title = 'Your application has been submitted.';
          this.dialogConfig.value = res;
          this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
          this.sendEmail('reinstatement');
        }
      });
    }
  }


  onCountryChange(event: any) {
    const id = this.countryList?.filter((country: any) => country.countryName === event.value)[0].id
    if (event.value) {
      this.sppdashboardService.getRegion(id).subscribe((response: any) => {
        this.filteredRegion.push(response)
        localStorage.setItem('selectedCountry', this.filteredRegion[0].countryName)
        localStorage.setItem('selectedRegion', this.filteredRegion[0].regionName)

        this.reinstatementStepOne.patchValue({
          region: this.filteredRegion[0].regionName
        });
      })

      this.filteredRegion = [];
    }

    this.sppdashboardService.getTimeZonesByCountryName(event.value).subscribe((response: any) => {
      if (response.success) {
        this.timezoneList = response.data;
      }
    }, (error: any) => {
      console.error("Error fetching Timezone List", error);
    });
  }



  // ///////////////////////////////////////////////////////////////////////

  // ALUMNI SECTION START HERE

  // ////////////////////////////////////////////////////////////////////////


  initAlumniForm() {
    this.alumniForm = this._fb.group({
      firstname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      email: [{ value: '', disabled: true }, [Validators.required]],
      alumniText: [''],
      alumniReasons: [[], [this.checkboxRequired.bind(this)]],
      mctAlumniAgreement: [{ value: false, disabled: true }, [Validators.required]]
    });
  }

  // Custom validator for checkbox field
  checkboxRequired(control: any) {
    const value = control.value;
    return value && value.length > 0 ? null : { required: true };
  }

  onReasonChange(event: any, reasonValue: string): void {
    const currentReasons = this.alumniForm.get('alumniReasons')?.value || [];

    if (event.checked) {
      // Add reason if checked
      if (!currentReasons.includes(reasonValue)) {
        currentReasons.push(reasonValue);
      }
    } else {
      // Remove reason if unchecked
      const index = currentReasons.indexOf(reasonValue);
      if (index > -1) {
        currentReasons.splice(index, 1);
      }
    }

    this.alumniForm.get('alumniReasons')?.setValue([...currentReasons]);
    // Mark the field as touched to trigger validation display
    this.alumniForm.get('alumniReasons')?.markAsTouched();
  }

  isReasonSelected(reasonValue: string): boolean {
    const currentReasons = this.alumniForm.get('alumniReasons')?.value || [];
    return currentReasons.includes(reasonValue);
  }

  // Getter for easy access to checkbox form control
  get alumniReasonsControl() {
    return this.alumniForm.get('alumniReasons');
  }

  // Helper method to check if MCT Alumni Agreement is valid (checked)
  isMctAlumniAgreementValid(): boolean {
    const control = this.alumniForm.get('mctAlumniAgreement');
    return control?.value === true;
  }

  submitAlumniForm() {
    this.alumniForm.markAllAsTouched();
    this.alumniFormSubmitted = true;
    if (this.alumniForm.valid && this.isMctAlumniAgreementValid()) {
      this.disablesubmitBtn = true;
      this.sppdashboardService.sumbmitAluminiRequest(this.alumniForm.value, this.userId).subscribe((res: any) => {
        if (res?.success === true) {
          this.alumniFormSubmitted = false;
          this.disablesubmitBtn = false;
          res.message = `
          Thank you for submitting your application to become an MCT Alumni.<br/>
          Your application is approved, and you may continue to access the MCT Portal and the MCT Lounge as part of your benefits through this program.<br/> 
          For questions, please contact us at <a aria-label="Email MCT Support at mctpvsupport@pearson.com" href="mailto:mctpvsupport@pearson.com">mctpvsupport&#64;pearson.com</a> - we’re here to help!`;
          res.title = 'Alumni Request Approved Successfully';
          this.dialogConfig.value = res;
          this.simpleDialog = this.dialogModel.open(UserDataModalComponent, { data: this.dialogConfig });
          this.sendEmail('alumni');
        }
      });
    }
  }

  sendEmail(type: string): void {
    if (this.alumniForm.getRawValue()?.email) {
      const tempObject = {
        "recipientEmail": type === 'alumni' ? this.alumniForm.getRawValue()?.email : this.reinstatementStepOne.getRawValue()?.email,
        "subject": type === 'alumni' ? 'Alumni Request Approved' : 'Reinstatement Request Submitted',
        "templateName": type === 'alumni' ? 'MCTAlumniApproval' : 'MCTTestOutSubmittedNew',
        "language": "en",
        "customContext": "{}"
      }

      this.helpService.sendEmail(tempObject).subscribe((res: any) => {
        if (res.success === true) {
          /* empty */
        } else {
          this.snackbar.open(res.errors, '', { verticalPosition: 'top', horizontalPosition: 'center' });
        }
      }, (error: any) => {
        const errMsg = error?.error?.errors ? error?.error?.errors : [error?.error?.error];
        errMsg?.map((msg: string) => {
          this.snackbar.open(msg, '', { verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['warning'] });
        });
      })
    }
  }

  onCancel() {
    this.alumniFormSubmitted = false;
    this.disablesubmitBtn = false;
    this.sectiontoShow = 'selectionPage';
    this.isCheckboxSelected = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  alumniagrementDoc = () => {
    this.alumniForm.get('mctAlumniAgreement')?.enable();
    const pdfUrl = environment.BASE_URL + `/ptp/api/spp/mct/mct_alumni_agreement/download`;
    window.open(pdfUrl, '_blank');
  }


  //////////////////////////////////////////////////////////////////////

  selectOption(option: 'MCT' | 'Alumni'): void {
    this.selectedOption = option;
    console.log('Selected option:', option);
  }

  isSelected(option: 'MCT' | 'Alumni'): boolean {
    return this.selectedOption === option;
  }


  renewMCT() {
    const endDate = new Date(this.mctSubscriptionEndDate);
    const today = new Date();
    const threeYearsAgo = new Date(today);
    threeYearsAgo.setFullYear(today.getFullYear() - 3);
    const isExpiredMoreThanThreeYears = endDate < threeYearsAgo;
    if (isExpiredMoreThanThreeYears) {
      this.router.navigate(['/dashboard'], {
        state: {
          source: 'mct-renewal',
          userType: 'MCT',
        }
      });
    } else {
      this.sectiontoShow = 'mctReinstatementSection';
      this.FTEDialog = this.dialogModel.open(FTEModalComponent, {
        width: '600px',
      });


      this.FTEDialog.afterClosed().subscribe((result) => {     
      if(result == 'yes'){
        // take user to ISCP flow
        this.router.navigate(['/dashboard'], {
          state: {
            source: 'less-than-three',
          }
        });
        
      } 
    });

    }
  }

  renewAlumni() {
    this.alumniFormSubmitted = false;
    this.disablesubmitBtn = false;
    this.sectiontoShow = 'alumniSection';
  }

  ngOnDestroy(): void {
    // Clear the interval when component is destroyed
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
  }

}
